import { netWorth, fmtMoney } from "@/lib/netWorth";

export const NetWorthSnapshot = ({ enquiry }) => {
  const nw = netWorth(enquiry);
  if (!nw) return null;
  return (
    <div data-testid={`enquiry-net-worth-${enquiry.id}`} className="mt-3 inline-flex flex-wrap items-baseline gap-x-4 gap-y-1 border border-[#0A2333]/15 bg-[#F9F8F4] px-4 py-2">
      <span className="text-[10px] uppercase tracking-[0.2em] text-[#4A524D]">Est. net worth</span>
      <span className="font-serif text-xl text-[#0A2333]" data-testid={`enquiry-net-worth-total-${enquiry.id}`}>{fmtMoney(nw.total)}</span>
      <span className="text-xs text-[#4A524D]">
        {nw.parts.map(([label, v, sign]) => `${label} ${sign < 0 ? "−" : "+"}${fmtMoney(v)}`).join("  ·  ")}
      </span>
    </div>
  );
};
